const resources = {
    navbar: {
        DashboardLink: 'Dashboard',
        UserLink: 'User',
        userAllLink: 'All',
        userCreateLink: 'Create',
        EmployeeLink: 'Employee',
        employeeSearchLink: 'Search',
        employeePunchesLink: 'Punches',
        employeeAttendanceLink: 'Attendance',
        eventsLink: 'Events',
        eventCelebrationsLink: 'Celebrations',
        ourEventsLink: 'Our Events',
        eventsMediaHubLink: 'Media Hub',
        timeOffLink: 'Time Off',
        timeOffHolidayLink: 'Holidays',
        timeOffLeavesLink: 'Leaves',
        policyLink: 'Policies',
        settingsLink: 'Settings',
        headerText: 'HRMS',
        footerText: 'Powered by OKRUTI'
    },
    userCardDataContent: {
        yourProfileLinkText: "Profile",
        yourEventsLinkText: "Events",
        yourNotesLinkText: 'My Notes',
        changePasswordLinkText: "Change Password",
        logoutSuccessText: "Logout Success!",
        logoutErrorMessage: "Unable to Logout the User:",
        toastAutoCloseTime: 1500,
        logoutButtonText: "Logout",
    },
    userNotificationCard: {
        unreadText: "Unread",
        readText: "Read",
        notificationsText: "Notifications",
        noNotificationsText: "No Notification"
    },
    usersImport: {
        columns: [],
        requiredFields: [
            //only required
            // "name_title",
            "name_firstName",
            "name_lastName",
            "gender",
            "qualification",
            "joiningDate",
            "designation",
            "dateOfBirth",
            "type",
            "permanentAddress_city",
            "permanentAddress_line1",
            "permanentAddress_line2",
            "permanentAddress_state",
            "permanentAddress_zipCode",
            "presentAddress_city",
            "presentAddress_line1",
            "presentAddress_line2",
            "presentAddress_state",
            "presentAddress_zipCode",
            "contact",
            "officialEmail",
            "employeeCode",
        ],
        uniqueFields: [
            //unique and required
            "contact",
            "email",
            "officialEmail",
            "employeeCode",
            //  only unique not required
            "bankDetail_accountNumber",
            "familyDetails_mobileNumber",
        ],
        payloadKeys: {
            "serial number": "serialNumber",
            "active": "active",
            "age": "age",
            "bankdetails_accountholdername": "bankDetail_accountHolderName",
            "bankdetails_accountnumber": "bankDetail_accountNumber",
            "bankdetails_branchcode": "bankDetail_branchCode",
            "bankdetails_branchname": "bankDetail_branchName",
            "bankdetails_ifsccode": "bankDetail_ifscCode",
            "bloodgroup": "bloodGroup",
            "contact": "contact",
            "dateofbirth": "dateOfBirth",
            "designation": "designation",
            "email": "email",
            "employeecode": "employeeCode",
            "joiningdate": "joiningDate",
            "experiences_annualctc": "experiences_annualCTC",
            "experiences_designation": "experiences_designation",
            "experiences_duration_startdate": "experiences_duration_startDate",
            "experiences_duration_enddate": "experiences_duration_endDate",
            "experiences_employername": "experiences_employerName",
            "experiences_reasonforleaving": "experiences_reasonForLeaving",
            "experiences_skills": "experiences_skills",
            "experiences_totalexperience": "experiences_totalExperience",
            "familydetails_gender": "familyDetails_gender",
            "familydetails_name": "familyDetails_name",
            "familydetails_mobilenumber": "familyDetails_mobileNumber",
            "familydetails_relationtype": "familyDetails_relationType",
            "gender": "gender",
            "name_firstname": "name_firstName",
            "name_middlename": "name_middleName",
            "name_lastname": "name_lastName",
            "name_title": "name_title",
            "officialemail": "officialEmail",
            "permanentaddress_city": "permanentAddress_city",
            "permanentaddress_line1": "permanentAddress_line1",
            "permanentaddress_line2": "permanentAddress_line2",
            "permanentaddress_state": "permanentAddress_state",
            "permanentaddress_zipcode": "permanentAddress_zipCode",
            "presentaddress_city": "presentAddress_city",
            "presentaddress_line1": "presentAddress_line1",
            "presentaddress_line2": "presentAddress_line2",
            "presentaddress_state": "presentAddress_state",
            "presentaddress_zipcode": "presentAddress_zipCode",
            "present_address same as permanent_ address":
                "presentAddressIsSameAsPermanent",
            "qualification": "qualification",
            "totalexperience": "totalExperience",
            "type": "type",
        },
        mainHeading: "Import Employees",
        uploadFileButtonText: "Upload .CSV File",
        saveAllButtonText: "Save All",
    },
    userDataTable: {
        userDetailModalTitle: "USER DETAILS",
        userEditModalTitle: "Edit User",

    },
    usersCreate: {
        userCreateHeading: "Create User",
        titleLabel: "Title",
        titleName: "title",
        titleMessage: "Select title",
        titlePlaceholder: "Select title",
        firstNameLabel: "First Name",
        firstNameName: "firstName",
        firstNameMessage: "First Name is not valid!",
        firstNameRequiredMessage: "Enter First Name!",
        firstNamePlaceholder: "Enter First Name",
        middleNameLabel: "Middle Name",
        middleNameName: "middleName",
        middleNamePlaceholder: "Enter Middle Name",
        middleNameMessage: "Input Middle Name!",
        lastNameLabel: "Last Name",
        lastNameName: "lastName",
        lastNamePlaceholder: "Enter Last Name",
        lastNameRequiredMessage: "Input Last Name!",
        lastNameMessage: "Last name is not valid!",
        emailLabel: "Email",
        emailName: "email",
        emailPlaceholder: "Enter Email",
        emailRequiredMessage: "Input Email!",
        emailMessage: "Enter a valid email!",
        rolesLabel: "Roles",
        rolesName: "roles",
        rolesPlaceholder: "Enter Roles",
        rolesRequiredMessage: "Input atleast a role!",
        rolesMessage: "Enter a valid role!",
    },
    userCreateSuccess: {
        description1: "You have successfully registered with the ID:",
        description2: "You’re all set to begin exploring your profile and managing your account.",
        description3: "To continue, please proceed to the next step, where you can add your employee details to complete your profile.",
        noThanksButton: "No Thanks",
        yesCreateEmployeeButton: "Yes!",
        confirmationText: "Hi , Do you want to fill employee form now ?",
    },
    usersList: {
        clearKeysLocalStorage: [
            'personalDetail',
            'bankDetail',
            'familyDetails',
            'presentAddress',
            'contact',
            'permanentAddress',
            'bankingDetails',
            'previousExperiences'
        ]
    },
    employee: {
        title: 'PRIVACY POLICY PAGE',
        description: 'This is Okruti IT Consulting Privacy Policy page',
    },
    createEmployee: {},
    searchEmployee: {
        pageHeader: "Employee Search",
        form: {
            nameLabel: "Name",
            namePlaceholder: "Name",
            employeeCodeLabel: `Employee Code`,
            employeeCodePlaceholder: `Employee Code`,
            joiningDateLabel: `Joining Date`,
            joiningDatePlaceholder: `Joining Date`,
            designationLabel: "Designation",
            designationPlaceholder: "Designation",
            documentNumberLabel: `Document Number`,
            documentNumberPlaceholder: `Document Number`,
        }
    },
    searchEmployeeTable: {
        tableColumns: {
            employeeCode: "Employee Code",
            name: "Name",
            designation: "Designation",
            contact: "Mobile Number",
            email: "Email",
            joiningDate: "Joining Date",
            actions: "Actions"
        },
        deleteConfirmationMessage: "Are you sure to delete?",
    },
    policyPage: {
        emptyPageTitle: "Oops! It's a bit empty here... 📋",
        adminEmptyPageTitle: "Looks like you haven't uploaded any policies yet",
        userEmptyPageTitle: "No Policies yet",
        uploadFirstPolicyText: "Upload Your First Policy",
        uploadPolicyButton: "Upload Policy",
    },

    leaveRequest: {
        cancelButton: 'Cancel',
        requestCreatedSuccessMessage: "Your Leave has been created and will be reviewed shortly!",
        requestCreatedErrorMessage: "Something went wrong during leave submission!",
        pageHeader: "Leave Request",
        form: {
            leaveTypeLabel: "Select Leave Type",
            leaveTypePlaceholder: "Leave Type",
            leaveDateLabel: "leave Date",
            leaveStartDateLabel: "From Date",
            leaveEndDateLabel: "To Date",
            leaveSessionLabel: "Select Session",
            reasonLabel: "Reason for Leave",
            addDateButtonText: '+ Add more dates'
        }
    },
    events: {
        eventCardHeading: 'Today\'s Event',
        workAnniversaryLabel: 'Work Anniversary',
        birthdayLabel: 'Birthday',
        customEventLabel: 'Custom Events'
    },
    attendanceCard: {
        employeeLogText: "Employee Log",
        checkInText: 'Check In',
        checkOutText: 'Check Out',
        workingHoursText: 'Working Hours'
    },
    weatherCard: {
        temperatureLabel: 'Temperature',
        windLabel: 'Wind',
        rainLabel: 'Rain',
        todayLabel: 'Today',
        dateLabel: 'Date',
    },
    commonButtonText: {
        searchButton: 'Search',
        resetButton: 'Reset',
        updateButton: 'Update',
        createButton: 'Create',
        clearButton: 'Clear',
        viewButton: 'View',
        submitButton: 'Submit',
        cancelButton: 'Cancel',
        downloadButton: 'Download',
        uploadButton: 'Upload',
        deleteButton: 'Delete',
        addButton: 'Add',
    },

}

export default resources;
